export default {
  single: 1,
  single_by_dictionary: 2,
  many: 3,
  many_single_by_dictionary: 4,
  many_many_by_dictionary: 5,
};
